import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../../shared/shared.module';
import { GlobalLayoutModule } from '../../core/global-layout/global-layout.module';



@NgModule({
  declarations: [
    // DashboardComponent
  ],
  imports: [
    CommonModule,
    //DashboardRoutes,
    SharedModule,
    GlobalLayoutModule,
    // TaskModule

  ]
})
export class DashboardModule { }
